// Third Party
import nookies, { setCookie } from 'nookies';

import {
  NextApiRequest,
  NextApiResponse,
  GetServerSidePropsContext,
} from 'next';

// Utils
import { isProd } from './predicates';

const referralCodeKey = '__savvy_referral_code__';

type NextApiContext = {
  req: NextApiRequest;
  res: NextApiResponse;
};

type IsomorphicContext = GetServerSidePropsContext | NextApiContext | undefined;

export function getReferralCode(ctx: any): string | undefined {
  const cookies = nookies.get(ctx);

  const referralCode = cookies[referralCodeKey];

  if (referralCode) {
    return referralCode;
  } else {
    return undefined;
  }
}

export function setReferralCode(
  ctx: IsomorphicContext,
  referralCode: string
): void {
  if (ctx !== undefined) {
    nookies.set(ctx, referralCodeKey, referralCode, {
      sameSite: 'lax',
      path: '/',
      secure: isProd,
      maxAge: 5 * 60,
      expires: new Date(Date.now() + 5 * 60 * 1000),
    });
  } else {
    setCookie(undefined, referralCodeKey, referralCode, {
      sameSite: 'lax',
      path: '/',
      secure: isProd,
      maxAge: 5 * 60,
      expires: new Date(Date.now() + 5 * 60 * 1000),
    });
  }
}

export function removeReferralCode(ctx: IsomorphicContext): void {
  nookies.destroy(ctx, referralCodeKey, {
    path: '/',
  });
}
